import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ServoBikeProductType } from '@base/backend';

export function createBikeProductForm(): FormGroup<BikeProductFormModel> {
  return new FormGroup<BikeProductFormModel>({
    bikeProductType: new FormControl<ServoBikeProductType | null>(null, [Validators.required]),
    isEbike: new FormControl<boolean | null>(null, [Validators.required]),
    brand: new FormControl<string | null>(null, [Validators.required]),
    model: new FormControl<string | null>(null, [Validators.required]),
    serialNumber: new FormControl<string | null>(null, [Validators.required])
  });
}

export interface BikeProductFormModel {
  bikeProductType: FormControl<ServoBikeProductType | null>;
  isEbike: FormControl<boolean | null>;
  brand: FormControl<string | null>;
  model: FormControl<string | null>;
  serialNumber: FormControl<string | null>;
}

